import React, { useState } from 'react'
import context from '@/context'
import PropTypes from 'prop-types'
import { ValidationBoundary } from '@/components/validation'
import { ModalBody } from 'reactstrap'
import { BasicHeader } from '@/dialogs/common/basicHeader'
import { FormLoader, FormRow } from '@/components/changeRequests'
import { realEstateStatus } from '@/enums/RealEstateStatus'
import { TabNavItems, TabPane, TabContent } from '@/components/tabs'
import { AddressForm } from '@/dialogs/address'
import { ChangeItemDialogFooter } from '@/dialogs/common/changeItemDialogFooter'
import { decimalMaxChangeItemValue } from '@/utils/constants'

export const RealEstateDialog = function RealEstateDialog (props) {
  return (
    <ValidationBoundary>
      <BasicHeader title='Institutions.RealEstate' {...props} />
      <RealEstateForm {...props} />
    </ValidationBoundary>
  )
}

RealEstateDialog.propTypes = {
  isOriginal: PropTypes.bool,
  loadData: PropTypes.func,
  value: PropTypes.object,
  onAction: PropTypes.func,
  closeDialog: PropTypes.func.isRequired
}

const RealEstateForm = function RealEstateForm (props) {
  const [activeTabId, setActiveTabId] = useState('1')

  return (
    <FormLoader {...props} render={() =>
      <React.Fragment>
        <ModalBody>
          <React.Fragment>
            <TabNavItems activeTabId={activeTabId} onClick={setActiveTabId}
              items={[
                { id: '1', text: 'Common.Details' },
                { id: '2', text: 'Persons.Address' }
              ]} />
            <TabContent activeTab={activeTabId}>
              <TabPane tabId='1'>
                <div className='row'>
                  <div className='col-6'>
                    <FormRow label='Institutions.OwnershipType' name='ownershipType' target={props.target} inputType='lookup'
                      dataSource={context.cache.getOwnershipTypes} clientSide isCodeList required />
                    <FormRow label='Institutions.PropertyType' name='propertyType' target={props.target} inputType='lookup'
                      dataSource={context.cache.getPropertyTypes} clientSide isCodeList required />
                    <FormRow label='Institutions.Settlement' name='settlement' target={props.target} inputType='date' />
                    <FormRow label='Institutions.SettlementExpiration' name='settlementExpiration' target={props.target} inputType='date' />
                    <FormRow label='Institutions.ExtensionObtained' name='extensionObtained' target={props.target} inputType='checkbox' />
                    <FormRow label='Institutions.ExtensionDate' name='extensionDate' target={props.target} inputType='date' />
                  </div>
                  <div className='col-6'>
                    <FormRow label='Institutions.InvestmentRatio' name='investmentRatio' target={props.target} inputType='number'
                      inputProps={{ min: 0, percentage: true, integerOnly: true }} />
                    <FormRow label='Institutions.PurchaseDate' name='purchaseDate' target={props.target} inputType='date' />
                    <FormRow label='Institutions.MarketCost' name='marketCost' target={props.target} inputType='number' maxValue={decimalMaxChangeItemValue} />
                    <FormRow label='Institutions.NominalCost' name='nominalCost' target={props.target} inputType='number' maxValue={decimalMaxChangeItemValue} />
                    <FormRow label='Institutions.PartInvested' name='partInvested' target={props.target} inputType='checkbox' />
                    <FormRow label='Institutions.Status' name='status' target={props.target} inputType='enum'
                      inputProps={realEstateStatus} required />
                  </div>
                </div>
                <FormRow label='Common.Description' name='description' target={props.target} inputType='textarea' />
              </TabPane>
              <TabPane tabId='2'>
                <AddressForm prefix='address.' hidePrimaryCheckbox target={props.target} />
              </TabPane>
            </TabContent>
          </React.Fragment>
        </ModalBody>
        <ChangeItemDialogFooter {...props} />
      </React.Fragment>
    } />
  )
}

// <div className='row'>
//     <div className='col-12'>
//     <label><Resx name='Common.Description' /></label><br />
//     <PropertyRenderer name='description' inputType='textarea' />
//   </div>
//   </div>

export default {
  modalProps: {
    size: 'lg'
  },
  component: RealEstateDialog
}



// WEBPACK FOOTER //
// ./src/dialogs/realEstate.js